import { render, staticRenderFns } from "./DistributorRegistrationForm.vue?vue&type=template&id=38d18be6&scoped=true&"
import script from "./DistributorRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./DistributorRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./DistributorRegistrationForm.vue?vue&type=style&index=0&id=38d18be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d18be6",
  null
  
)

export default component.exports